/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_ASSET,
  ASSET_PATH,
  READ_ASSET_LIST,
  CREATE_ASSET,
  UPDATE_ASSET,
  READ_TIMELINE,
} from 'domain/finance/assets/useAssetService';
import AssetList from 'domain/finance/assets/List';
import AssetViewPage from 'domain/finance/assets/Show';
import AssetCreatePage from 'domain/finance/assets/createupdate/Create';
import AssetUpdatePage from 'domain/finance/assets/createupdate/Update';
import ShowAsset from 'domain/finance/assets/shared/ShowAsset';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import AssetTimelinePage from 'domain/finance/assets/Timeline';

const useAssetRoute = () => {
  const routers = createRoute({ listRoute: ASSET_PATH });

  return { ...routers, copyEntityRoute: `${routers.singleEntityRoute}/copy` };
};

const AssetRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const {
    listRoute,
    singleEntityRoute,
    createRoute: createAssetRoute,
    copyEntityRoute,
    updateRoute,
    timelineRoute,
  } = useAssetRoute();

  return (
    <ProtectedRouter basePath={ASSET_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_ASSET_LIST}>
              <AssetList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={createAssetRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_ASSET}>
              <AssetCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={copyEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={CREATE_ASSET}>
              <AssetCreatePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={updateRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={UPDATE_ASSET}>
              <ShowAsset>
                <AssetUpdatePage />
              </ShowAsset>
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={timelineRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_TIMELINE}>
              <AssetTimelinePage />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_ASSET}>
              <AssetViewPage />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

AssetRouter.getRouterPath = () => `${ASSET_PATH}/*`;

export default AssetRouter;
